import { GatsbyImage } from 'gatsby-plugin-image';
import propType from 'prop-types';
import React, { useRef } from 'react';
import { useFindElementHeight } from '../../hooks';

export default function Hero({
  image,
  staticImage,
  content,
  imageStyle,
  showOverlay
}) {
  const ref = useRef();
  const contentHeight = useFindElementHeight(ref);

  return (
    <div className="hero">
      {/* You can use a StaticImage component if the image is statically imported */}
      <div
        className="hero__bg-image"
        style={{
          height: contentHeight,
          objectPosition: 'center top',
          ...imageStyle
        }}
      >
        {staticImage || (
          <GatsbyImage
            image={image}
            style={{
              height: '100%'
            }}
            alt="Thumbnail Background"
            formats={['auto', 'webp', 'avif']}
          />
        )}
      </div>
      <div className="hero__content" ref={ref}>
        {showOverlay && <div className="hero__overlay-bg" />}
        {/* Any content here will be centered in the component */}
        {content}
      </div>
    </div>
  );
}

Hero.defaultProps = {
  showOverlay: true,
  imageStyle: {},
  staticImage: null,
  image: {}
};

Hero.propTypes = {
  image: propType.shape({}),
  staticImage: propType.node,
  content: propType.node.isRequired,
  imageStyle: propType.shape({}),
  showOverlay: propType.bool
};
